function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = _has;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_has.js
// module id = 35
// module chunks = 0